import { Editor } from "primereact/editor"
import Quill from "quill"
import QuillMention from "quill-mention"
Quill.register('modules/mention', QuillMention)

const CommentField = ({ placeholder, value, onTextChange, disabled, style, suggestions }
) => {

  const modules = {
    mention: {
      mentionDenotationChars: ["@"],
      source: (searchTerm, renderList) => {
        let matches = []
        if (searchTerm.length === 0) {
          matches = suggestions
        } else {
          matches = suggestions.filter(suggestion => {
            return suggestion.value.toLowerCase().startsWith(searchTerm.toLowerCase())
          })
        }
        renderList(matches, searchTerm)
      },
      renderItem: (item, searchTerm) => {
        let span = document.createElement('span')
        span.textContent = item.value
        if (!item.choosable) {
          span.className = 'disabled'
        } else {
          span.className = 'choosable'
        }
        return span
      }
    },
    //Remove all unwanted controls
    keyboard: {
      bindings: {
        bold: {
          key: 'B',
          shortKey: true,
          handler: () => false
        },
        underline: {
          key: 'U',
          shortKey: true,
          handler: () => false
        },
        italic: {
          key: 'I',
          shortKey: true,
          handler: () => false
        },
        strike: {
          key: 'S',
          shortKey: true,
          handler: () => false
        },
        list: {
          key: 'L',
          shiftKey: true,
          handler: () => false
        },
        link: {
          key: 'K',
          shortKey: true,
          handler: () => false
        },
      }
    }
  }

  return (
    <Editor
      placeholder={placeholder ? placeholder : ""}
      value={value}
      modules={modules}
      onTextChange={(e) => {
        //Prevent user from adding unwanted attributes by copy/pasting
        const anyUnwantedAttr = e.delta.ops.some((item) => {
          return item.hasOwnProperty("attributes")
        })
        if (!anyUnwantedAttr) {
          onTextChange(e.htmlValue)
        } else {
          //If unwanted attributes are found return the original value to prevent the change
          onTextChange(value ? value : "" + " ")
        }
      }}
      headerTemplate={<></>}
      readOnly={disabled}
      className="custom_comment_input"
      style={style}
    />
  )
}

export default CommentField 